export const removeStartingSlash = (URL: string): string => {
  const REGEX = new RegExp(/^\/+/);
  return `${URL.toLowerCase().trim().replace(REGEX, '')}`;
};

/**
 * REMOVES slash of URL if found at START of link
 * and RE-ADDS a slash to prevent double slashes in links
 * @param {*} URL - {string}
 */
export const startingSlashIt = (URL: string): string => {
  const REGEX = new RegExp(/^\//g);
  return `/${URL.toLowerCase().trim().replace(REGEX, '')}`;
};

/**
 * REMOVES slash of URL if found at END of link
 * and RE-ADDS a slash to prevent double slashes in links
 * @param {*} URL - {string}
 */
export const trailingSlashIt = (URL: string): string => {
  const REGEX = new RegExp(/\/$/g);
  return `${URL.toLowerCase().trim().replace(REGEX, '')}/`;
};

/**
 * Checks if HTML string is just empty tags without text content.
 * Returns true/false value
 * Example:
 *  let HTMLsample = '<p><br/></p>'
 *  HTMLhasEmptyText(HTMLsample) will yield false
 * @param {*} html - {string}
 * @return {boolean}
 */
export const isEmptyHTML = ((html: string) =>
  html.replace(/(<([^>]+)>)/ig, '').trim() === ''
);

export const isBot = () => {
  const botPattern = '(googlebot\/|Googlebot-Mobile|Googlebot-Image|Google favicon|Mediapartners-Google|bingbot|slurp|java|wget|curl|Commons-HttpClient|Python-urllib|libwww|httpunit|nutch|phpcrawl|msnbot|jyxobot|FAST-WebCrawler|FAST Enterprise Crawler|biglotron|teoma|convera|seekbot|gigablast|exabot|ngbot|ia_archiver|GingerCrawler|webmon |httrack|webcrawler|grub.org|UsineNouvelleCrawler|antibot|netresearchserver|speedy|fluffy|bibnum.bnf|findlink|msrbot|panscient|yacybot|AISearchBot|IOI|ips-agent|tagoobot|MJ12bot|dotbot|woriobot|yanga|buzzbot|mlbot|yandexbot|purebot|Linguee Bot|Voyager|CyberPatrol|voilabot|baiduspider|citeseerxbot|spbot|twengabot|postrank|turnitinbot|scribdbot|page2rss|sitebot|linkdex|Adidxbot|blekkobot|ezooms|dotbot|Mail.RU_Bot|discobot|heritrix|findthatfile|europarchive.org|NerdByNature.Bot|sistrix crawler|ahrefsbot|Aboundex|domaincrawler|wbsearchbot|summify|ccbot|edisterbot|seznambot|ec2linkfinder|gslfbot|aihitbot|intelium_bot|facebookexternalhit|yeti|RetrevoPageAnalyzer|lb-spider|sogou|lssbot|careerbot|wotbox|wocbot|ichiro|DuckDuckBot|lssrocketcrawler|drupact|webcompanycrawler|acoonbot|openindexspider|gnam gnam spider|web-archive-net.com.bot|backlinkcrawler|coccoc|integromedb|content crawler spider|toplistbot|seokicks-robot|it2media-domain-crawler|ip-web-crawler.com|siteexplorer.info|elisabot|proximic|changedetection|blexbot|arabot|WeSEE:Search|niki-bot|CrystalSemanticsBot|rogerbot|360Spider|psbot|InterfaxScanBot|Lipperhey SEO Service|CC Metadata Scaper|g00g1e.net|GrapeshotCrawler|urlappendbot|brainobot|fr-crawler|binlar|SimpleCrawler|Livelapbot|Twitterbot|cXensebot|smtbot|bnf.fr_bot|A6-Indexer|ADmantX|Facebot|Twitterbot|OrangeBot|memorybot|AdvBot|MegaIndex|SemanticScholarBot|ltx71|nerdybot|xovibot|BUbiNG|Qwantify|archive.org_bot|Applebot|TweetmemeBot|crawler4j|findxbot|SemrushBot|yoozBot|lipperhey|y!j-asr|Domain Re-Animator Bot|AddThis|Prerender)';
  const regex = new RegExp(botPattern, 'i');
  return regex.test(navigator.userAgent);
};

// A Regex to check for http or https URLs
export const EXTERNAL_URL_REGEX = /^(http:\/\/www\.|https:\/\/www\.|http:\/\/|https:\/\/)?[a-z0-9]+([\-\.]{1}[a-z0-9]+)*\.[a-z]{2,5}(:[0-9]{1,5})?(\/.*)?$/g;

export const isExternalLink = (link) => !(link[0] === "/") && link.substr(0, 4) !== "http" || link.substr(0, 4) !== "www.";

/**
 * Truncates text according max length.
 * @param {*} str - {string}
 * @param {*} max - {number}
 * @param {*} endicator - {string}
 * @return {string}
 */
export const truncate = (str: string, max: number, endicator: string = '...') => {
  return str.length > max
    ? `${str.slice(0, max).trim()}${endicator}`
    : str;
};



// WEBPACK FOOTER //
// ./src/services/utils.ts